<template>
  <dialog
    ref="dialog"
    class="dialog"
    @click="click($event)"
    :style="[modelValue ? 'z-index: 999;' : 'z-index: 0; visibility: hidden;']"
  >
    <div v-if="modelValue" class="dialog-box">
      <div class="close" @click="onDialogAction(false)"></div>
      <div class="dialog-action">
        <p>{{ projectId ? `案件` : "" }}お問い合わせ</p>
        <p>
          入力頂いた内容はLINEのトークルーム投稿され、<br />事務局の方で順次確認させて頂きます。
        </p>
        <textarea
          v-model="contactDetail"
          class="dialog-text-area"
          required
          placeholder="お問い合わせ内容"
        ></textarea>
        <h6 v-show="isError" class="dialog-error-message">{{ error }}</h6>
        <div class="dialog-button-area">
          <common-button
            :data="{
              status: contactDetail ? 0 : 2,
              button: `送信する`,
            }"
            @click="contactDetail ? onDialogAction(true) : ''"
          ></common-button>
        </div>
      </div>
    </div>
  </dialog>
  <div class="l-modal" v-if="modelValue">
    <div :class="[modelValue ? 'l-modal__bg' : '']"></div>
  </div>
</template>

<script setup lang="ts">
import liff from "@line/liff";
import { ref } from "vue";
import CommonButton from "./CommonButton.vue";
import { ProjectStore } from "../store/ProjectStore";

const contactDetail = ref("");
const error = "内容を入力してください。";
const isError = ref(false);
const projectStore = ProjectStore();

// APIを公開
defineExpose({
  openContactDialog,
  closeContactDialog,
});

export type Props = {
  modelValue: boolean;
  projectId?: number;
};

// dialogの参照を保持する変数
const dialog = ref<HTMLDialogElement | null>(null);
// const open = ref(false);
const emit = defineEmits(["applyProject", "update:modelValue"]);
const props = defineProps<Props>();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = ($event: any) => {
  if (!$event || !$event.target) {
    isError.value = false;
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

const sendMessage = async () => {
  // メッセージ送信する
  if (!contactDetail.value) {
    isError.value = true;
    return;
  } else {
    isError.value = false;
    dialog?.value?.close();
  }
    // 問い合わせ内容をAPIにも送信する
    await projectStore.messages({
      message: props.projectId
        ? `案件ID: ${props.projectId}\n\n----お問い合わせ内容----\n\n${contactDetail.value}\n`
        : `----お問い合わせ内容----\n\n${contactDetail.value}\n`,
    });
  if (liff.isInClient()) {
    liff
      .sendMessages([
        {
          type: "text",
          text: props.projectId
            ? `案件ID: ${props.projectId}\n\n----お問い合わせ内容----\n\n${contactDetail.value}\n`
            : `----お問い合わせ内容----\n\n${contactDetail.value}\n`,
        },
      ])
      .then(() => {
        // Lineメッセージ画面に戻る
        liff.closeWindow();
      });
  }
};

// 外部に公開するAPI。ダイアログを開いて、終了
function openContactDialog() {
  dialog?.value?.showModal();
}
function closeContactDialog() {
  dialog?.value?.close();
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    sendMessage();
  } else {
    isError.value = false;
    dialog?.value?.close();
    emit("update:modelValue", false);
  }
}
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
@import "../assets/style/_mixin.scss";

@mixin p($font-weight, $font-size, $line-height) {
  font-style: normal;
  font-weight: $font-weight;
  font-size: $font-size;
  line-height: $line-height;
  align-items: center;
  text-align: center;
  color: #000000;
}
.l-modal {
  @include l-modal();
}
.l-modal__bg {
  @include l-modal__bg();
}
.dialog {
  overflow: auto;
  text-align: center;
  max-height: 402px;
  max-width: 315px;
  position: relative;
  z-index: 9999;
  border-width: 0;
}
.dialog-error-message {
  color: red;
}
.dialog-button-area {
  padding-top: 10px;
  width: 200px;
  margin: 0 auto;
}
.dialog-text-area {
  width: 248px;
  height: 100px;
  padding-left: 8px;
  padding-top: 8px;
  overflow-y: auto;
}
.dialog-action {
  text-align: center;
  p:nth-child(1) {
    @include p(600, 12px, 18px);
  }
  p:nth-child(2) {
    @include p(300, 10px, 15px);
  }
}
.close {
  position: absolute;
  display: block;
  right: 0px;
  top: 0px;
  width: 9px;
  height: 9px;
  padding: 15px;
}
.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 14px;
  background: #333;
}
.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
